/* GOLDENKING refonte — JS global (cartes produit, fiche produit, header). Chargé une fois. */
(function () {
  function money(c) {
    return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function sizedUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('width=') > -1) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* P0-2 : message d'erreur visible (toast) au lieu d'un échec silencieux */
  function gkrToast(msg) {
    try {
      var t = document.createElement('div');
      t.setAttribute('role', 'alert');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);z-index:1700;background:#1a1a1a;color:#fff;padding:12px 18px;border-radius:10px;font-size:14px;line-height:1.3;max-width:90vw;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.35);opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
      setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320); }, 4000);
    } catch (e) {}
  }

  /* ---- carte produit (grille) — ajout panier AJAX, pas de <form> ---- */
  function wireCard(el) {
    if (el.__gkr) return;
    el.__gkr = 1;
    var card = el.closest('.gkr-card');
    var now = el.querySelector('[data-now]'),
        old = el.querySelector('[data-old]'),
        badge = card && card.querySelector('[data-disc-badge]'),
        discNum = card && card.querySelector('[data-disc-num]'),
        cardImg = card && card.querySelector('.gkr-card__photo'),
        addBtn = el.querySelector('[data-gkr-add]');
    function setPrice(price, comp) {
      if (!(price > 0)) return; /* P1-1 : ne jamais afficher un prix 0/invalide (variante mal configurée) */
      var hasDisc = comp > price;
      if (now) now.textContent = money(price);
      if (old) { if (hasDisc) { old.textContent = money(comp); old.hidden = false; } else { old.hidden = true; } }
      if (badge) { if (hasDisc) { if (discNum) discNum.textContent = Math.round((1 - price / comp) * 100); badge.hidden = false; } else { badge.hidden = true; } }
    }
    var cardData = el.querySelector('[data-gkr-cardvariants]');
    if (cardData) {
      /* ---- Multi-options (Couleur + Taille) directement sur la carte ---- */
      var variants = [];
      try { variants = JSON.parse(cardData.textContent); } catch (e) { variants = []; }
      var selects = [].slice.call(el.querySelectorAll('[data-gkr-optsel]'));
      function optsOf(v) { return v.options || [v.option1, v.option2, v.option3]; }
      function resolve() {
        var combo = {};
        selects.forEach(function (s) { combo[+s.getAttribute('data-opt-pos')] = s.value; });
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          var o = optsOf(variants[i]), ok = true;
          for (var p in combo) { if (o[p - 1] !== combo[p]) { ok = false; break; } }
          if (ok) { v = variants[i]; break; }
        }
        if (v) {
          el.dataset.vid = v.id; setPrice(v.price, v.compare_at_price || 0); if (addBtn) addBtn.disabled = !v.available;
          if (cardImg && v.featured_image && v.featured_image.src) { cardImg.srcset = ''; cardImg.src = sizedUrl(v.featured_image.src, 600); }
        } else { el.dataset.vid = ''; if (addBtn) addBtn.disabled = true; }
      }
      selects.forEach(function (s) { s.addEventListener('change', resolve); });
      resolve();
    } else {
      /* ---- Mono-option (grammage CBD ou couleur/taille seule) ---- */
      var sel = el.querySelector('[data-gkr-select]');
      var apply = function (opt) {
        if (!opt) return;
        el.dataset.vid = opt.value;
        setPrice(+opt.dataset.price, +opt.dataset.compare || 0);
        if (cardImg && opt.dataset.img) { cardImg.srcset = ''; cardImg.src = opt.dataset.img; }
      };
      if (sel) { sel.addEventListener('change', function () { apply(sel.options[sel.selectedIndex]); }); }
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var vid = el.dataset.vid;
        if (!vid || addBtn.disabled) return;
        addBtn.disabled = true; addBtn.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (err) { return Promise.reject(err); }); })
          .then(function () { addBtn.disabled = false; addBtn.classList.remove('is-loading'); if (window.gkrOpenCart) { window.gkrOpenCart(); } else { window.location.href = '/cart'; } })
          .catch(function (err) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); gkrToast((err && err.description) || 'Produit indisponible pour le moment.'); });
      });
    }
  }

  /* ---- galerie PDP ---- */
  function wireGallery(g) {
    if (g.__gkr) return;
    g.__gkr = 1;
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (main && t.dataset.full) { main.src = t.dataset.full; main.removeAttribute('srcset'); }
      });
    });
  }

  /* ---- buybox PDP ---- */
  function wirePdp(box) {
    if (box.__gkr) return;
    box.__gkr = 1;
    var now = box.querySelector('.gkr-pdp-now'), old = box.querySelector('.gkr-pdp-old'),
        save = box.querySelector('.gkr-pdp-save'), per = box.querySelector('.gkr-pdp-per'),
        disc = box.querySelector('.gkr-pdp-disc'), discN = box.querySelector('[data-pdp-disc-num]'),
        total = box.querySelector('[data-pdp-total]'), hid = box.querySelector('input[name=id]'),
        qInput = box.querySelector('input[name=quantity]'), qShow = box.querySelector('[data-pdp-qty]');
    var st = { price: 0, comp: 0, qty: 1, short: '' };
    function render() {
      if (!(st.price > 0)) return; /* P1-1 : jamais afficher 0,00 € / -100% (variante prix 0 ou combo inexistant) */
      var hd = st.comp > st.price;
      if (now) { now.textContent = money(st.price); now.style.color = hd ? '#e23a2d' : ''; }
      if (per && st.short) per.textContent = '/ ' + st.short;
      if (old) { if (hd) { old.textContent = money(st.comp); old.hidden = false; } else { old.hidden = true; } }
      if (save) { if (hd) { save.textContent = 'Économisez ' + money(st.comp - st.price); save.hidden = false; } else { save.hidden = true; } }
      if (disc) { if (hd) { if (discN) discN.textContent = Math.round((1 - st.price / st.comp) * 100); disc.hidden = false; } else { disc.hidden = true; } }
      if (total) total.textContent = money(st.price * st.qty);
    }
    var addBtn = box.querySelector('.gkr-pdp-add');
    var dataEl = box.querySelector('[data-gkr-variants]');
    if (dataEl) {
      /* ---- Sélecteur multi-options (vêtements : Couleur / Taille…) ---- */
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var groups = [].slice.call(box.querySelectorAll('[data-opt-group]'));
      var galleryImg = document.querySelector('[data-gkr-gallery] [data-gallery-main] img');
      var sel = {};
      groups.forEach(function (g) {
        var pos = +g.getAttribute('data-opt-pos');
        var onb = g.querySelector('button.is-on') || g.querySelector('button');
        if (onb) sel[pos] = onb.getAttribute('data-opt-val');
      });
      function optsOf(v) { return v.options || [v.option1, v.option2, v.option3]; }
      function matches(v, combo) {
        var o = optsOf(v);
        for (var p in combo) { if (combo[p] != null && o[p - 1] !== combo[p]) return false; }
        return true;
      }
      function canHave(pos, value) {
        return variants.some(function (v) {
          if (!v.available) return false;
          var o = optsOf(v);
          if (o[pos - 1] !== value) return false;
          for (var p in sel) { if (+p === pos) continue; if (sel[p] != null && o[p - 1] !== sel[p]) return false; }
          return true;
        });
      }
      function update() {
        groups.forEach(function (g) {
          var pos = +g.getAttribute('data-opt-pos');
          g.querySelectorAll('button').forEach(function (b) {
            var val = b.getAttribute('data-opt-val');
            b.classList.toggle('is-on', sel[pos] === val);
            b.classList.toggle('is-soldout', !canHave(pos, val));
          });
        });
        var v = null;
        for (var i = 0; i < variants.length; i++) { if (matches(variants[i], sel)) { v = variants[i]; break; } }
        if (v) {
          st.price = v.price; st.comp = v.compare_at_price || 0; st.short = '';
          if (hid) hid.value = v.id;
          if (addBtn) { addBtn.disabled = !v.available; addBtn.classList.toggle('is-soldout', !v.available); }
          if (galleryImg && v.featured_image && v.featured_image.src) { galleryImg.srcset = ''; galleryImg.src = sizedUrl(v.featured_image.src, 900); }
        } else {
          if (hid) hid.value = '';
          if (addBtn) addBtn.disabled = true;
        }
        render();
      }
      groups.forEach(function (g) {
        var pos = +g.getAttribute('data-opt-pos');
        g.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () { sel[pos] = b.getAttribute('data-opt-val'); update(); });
        });
      });
      update();
    } else {
      /* ---- Mono-option grammage (CBD) — existant ---- */
      var pick = function (b) {
        box.querySelectorAll('.gkr-pdp-weights button').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        st.price = +b.dataset.price; st.comp = +b.dataset.compare || 0; st.short = b.dataset.short;
        if (hid) hid.value = b.dataset.vid;
        render();
      };
      box.querySelectorAll('.gkr-pdp-weights button').forEach(function (b) {
        b.addEventListener('click', function () { if (!b.hasAttribute('disabled')) pick(b); });
      });
      var on = box.querySelector('.gkr-pdp-weights button.is-on') || box.querySelector('.gkr-pdp-weights button');
      if (on) pick(on);
    }
    box.querySelectorAll('[data-pdp-qbtn]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.qty = Math.max(1, st.qty + (+b.dataset.pdpQbtn));
        if (qShow) qShow.textContent = st.qty;
        if (qInput) qInput.value = st.qty;
        render();
      });
    });
    var form = box.querySelector('[data-gkr-buy]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = hid ? hid.value : null, q = qInput ? (+qInput.value || 1) : 1;
        if (!vid) { gkrToast('Sélectionne une variante disponible avant d\'ajouter au panier.'); return; }
        var sb = form.querySelector('.gkr-pdp-add'); if (sb) sb.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: q }) })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (err) { return Promise.reject(err); }); })
          .then(function () { if (sb) sb.disabled = false; if (window.gkrOpenCart) { window.gkrOpenCart(); } else { window.location.href = '/cart'; } })
          .catch(function (err) { if (sb) sb.disabled = false; gkrToast((err && err.description) || 'Impossible d\'ajouter au panier. Réessaie.'); });
      });
    }
  }

  function progress() {
    var pr = document.querySelector('[data-gkr-progress] > i');
    if (!pr) return;
    var up = function () { var h = document.documentElement, max = h.scrollHeight - h.clientHeight; pr.style.width = (max > 0 ? Math.min(100, h.scrollTop / max * 100) : 0) + '%'; };
    up();
    window.addEventListener('scroll', up, { passive: true });
  }

  function header() {
    var h = document.getElementById('gkr-header');
    if (!h) return;
    var f = function () { h.classList.toggle('is-scrolled', window.scrollY > 20); };
    f();
    window.addEventListener('scroll', f, { passive: true });
  }

  /* ---- menu burger / drawer mobile ---- */
  function drawer() {
    var burger = document.querySelector('[data-gkr-burger]'), dr = document.querySelector('[data-gkr-drawer]');
    if (!burger || !dr || burger.__gkr) return;
    burger.__gkr = 1;
    function open() { dr.hidden = false; dr.classList.remove('is-closing'); document.documentElement.style.overflow = 'hidden'; burger.setAttribute('aria-expanded', 'true'); }
    function close() { dr.classList.add('is-closing'); burger.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; setTimeout(function () { dr.hidden = true; dr.classList.remove('is-closing'); }, 300); }
    burger.addEventListener('click', open);
    dr.querySelectorAll('[data-gkr-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) close(); });
  }

  /* ---- panier latéral « TON POCHON » ---- */
  function cartDrawer() {
    var dr = document.querySelector('[data-gkr-cart]');
    if (!dr || dr.__gkr) return; dr.__gkr = 1;
    var itemsEl = dr.querySelector('[data-gkr-cart-items]'),
        emptyEl = dr.querySelector('[data-gkr-cart-empty]'),
        footEl = dr.querySelector('[data-gkr-cart-foot]'),
        rewBox = dr.querySelector('[data-gkr-cart-reward-box]'),
        rewTxt = dr.querySelector('[data-gkr-cart-rewardtxt]'),
        rewFill = dr.querySelector('[data-gkr-cart-rewardfill]'),
        subEl = dr.querySelector('[data-gkr-cart-subtotal]'),
        freeMsgEl = dr.querySelector('[data-gkr-cart-freeship]'),
        shipEl = dr.querySelector('[data-gkr-cart-ship]'),
        totalEl = dr.querySelector('[data-gkr-cart-total]'),
        attr = function (a) { return parseFloat(dr.getAttribute(a)) || 0; },
        freeShip = attr('data-gkr-cart-threshold') * 100,
        reward = attr('data-gkr-cart-reward') * 100,
        reward2 = attr('data-gkr-cart-reward2') * 100,
        shipFlat = Math.round(attr('data-gkr-cart-shipflat') * 100),
        rewardLabel = dr.getAttribute('data-gkr-cart-rewardlabel') || 'cadeau mystère',
        rewardLabel2 = dr.getAttribute('data-gkr-cart-rewardlabel2') || 'produit mystère + un goodie',
        busy = false;
    var railEl = dr.querySelector('[data-gkr-cart-rail]'),
        railListEl = dr.querySelector('[data-gkr-cart-rail-list]'),
        inspId = parseInt(dr.getAttribute('data-gkr-cart-inspid'), 10) || 0,
        railFallback = railListEl ? railListEl.innerHTML : '',
        lastRecoSig = '__init__';
    var insBox = dr.querySelector('[data-gkr-cart-ins]'),
        insHandle = insBox ? (insBox.getAttribute('data-gkr-cart-inshandle') || '') : '',
        insMap = null, insVids = {}, insMaxCents = 0;
    function setCount(n) {
      document.querySelectorAll('[data-gkr-cart-count]').forEach(function (el) {
        el.textContent = el.tagName === 'EM' ? '(' + n + ')' : n;
        if (el.classList.contains('gkr-iconbtn__badge')) el.hidden = n < 1;
      });
    }
    function show(el, on) { if (el) el.hidden = !on; }
    function render(cart) {
      var insTotal = 0, realCount = 0;
      cart.items.forEach(function (it) { if (insVids[it.variant_id]) { insTotal += it.final_line_price; } else { realCount++; } });
      var prodTotal = cart.total_price - insTotal;   // total HORS assurance (cadeau + "vide" + reco se basent dessus)
      setCount(realCount);
      loadReco(cart);
      var empty = realCount < 1;
      show(rewBox, !empty && reward > 0); show(itemsEl, !empty); show(footEl, !empty); show(emptyEl, empty);
      if (empty) { var orphan = findInsLine(cart); if (orphan && !busy) change(orphan.line, 0); return; }
      if (rewBox && reward > 0) {
        var t = prodTotal, hasT2 = reward2 > reward, top = hasT2 ? reward2 : reward;
        var l1c = rewardLabel.charAt(0).toUpperCase() + rewardLabel.slice(1);
        rewFill.style.width = Math.min(100, t / top * 100) + '%';
        if (hasT2 && t >= reward2) {
          rewTxt.innerHTML = '👑 <b>Jackpot !</b> ' + rewardLabel + ' + ' + rewardLabel2 + ' offerts 🎁';
        } else if (t >= reward) {
          rewTxt.innerHTML = hasT2
            ? '🎉 <b>' + l1c + ' débloqué !</b> Plus que <b>' + money(reward2 - t) + '</b> pour ' + rewardLabel2 + ' 🎁'
            : '🎉 <b>' + l1c + ' débloqué !</b>';
        } else {
          rewTxt.innerHTML = 'Plus que <b>' + money(reward - t) + '</b> et on t\'offre ' + rewardLabel + ' 🎁';
        }
        var tiers = rewBox.querySelectorAll('[data-gkr-rewardtier]');
        for (var ti = 0; ti < tiers.length; ti++) {
          var lvl = tiers[ti].getAttribute('data-gkr-rewardtier');
          tiers[ti].classList.toggle('is-on', t >= (lvl === '2' ? reward2 : reward));
        }
      }
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        if (insVids[it.variant_id]) return '';
        var line = i + 1;
        var img = it.image ? (it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
        var gtxt = (it.variant_title || '').split(' ')[0], grams = parseFloat(gtxt), ql = '';
        if (grams > 0) ql = 'Quantité : ' + gtxt + ' (' + money(Math.round(it.price / grams)) + '/g)';
        else if (it.variant_title && it.variant_title !== 'Default Title') ql = it.variant_title;
        return '<div class="gkr-cart-item">'
          + '<div class="gkr-cart-item__media">'
          + '<button type="button" class="gkr-cart-item__rm" data-line="' + line + '" data-q="0" aria-label="Retirer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
          + (img ? '<a href="' + it.url + '" class="gkr-cart-item__img"><img src="' + img + '" alt="" loading="lazy"></a>' : '<span class="gkr-cart-item__img"></span>')
          + '</div>'
          + '<div class="gkr-cart-item__c">'
          + '<div class="gkr-cart-item__top"><a class="gkr-cart-item__t" href="' + it.url + '">' + it.product_title + '</a><span class="gkr-cart-item__p">' + money(it.final_line_price) + '</span></div>'
          + (ql ? '<span class="gkr-cart-item__q">' + ql + '</span>' : '')
          + '<div class="gkr-cart-qty"><button type="button" data-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Moins">–</button><span>' + it.quantity + '</span><button type="button" data-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Plus">+</button></div>'
          + '</div></div>';
      }).join('');
      var sub = cart.total_price, freeReached = freeShip > 0 && sub >= freeShip, ship = freeReached ? 0 : shipFlat;
      if (freeMsgEl) { /* P1-3 : progression livraison offerte */
        if (freeShip > 0 && cart.item_count > 0) { freeMsgEl.innerHTML = freeReached ? '🎉 Livraison offerte&nbsp;!' : 'Plus que <b>' + money(freeShip - sub) + '</b> pour la livraison offerte 🚚'; freeMsgEl.hidden = false; }
        else { freeMsgEl.hidden = true; }
      }
      if (subEl) subEl.textContent = money(sub);
      if (shipEl) shipEl.innerHTML = freeReached ? '<span class="gkr-cart__free">Offerte</span>' : money(ship);
      if (totalEl) totalEl.textContent = money(sub + ship);
      renderIns(cart);
    }
    function refresh() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render).catch(function () { gkrToast('Panier momentanément indisponible, réessaie.'); }); }
    function done() { busy = false; dr.classList.remove('is-busy'); }
    function change(line, q) { if (busy) return; busy = true; dr.classList.add('is-busy'); fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) }).then(function (r) { return r.json(); }).then(render).catch(function () {}).then(done); }
    function add(id, q) { if (busy) return; busy = true; dr.classList.add('is-busy'); fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: q }) }).then(function (r) { return r.ok ? r.json() : Promise.reject(); }).then(refresh).catch(function () {}).then(done); }
    /* ---- upsell INTELLIGENT : recommandations Shopify liées au panier (fallback = collection réglée) ---- */
    function showRail(on) { if (railEl) railEl.hidden = !on; }
    function upCard(p) {
      var v = null, i;
      for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      if (!v) v = p.variants[0];
      if (!v) return '';
      var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
      var cmp = (p.compare_at_price && p.compare_at_price > p.price) ? '<s>' + money(p.compare_at_price) + '</s> ' : '';
      return '<div class="gkr-cart-up">'
        + '<a href="' + p.url + '" class="gkr-cart-up__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
        + '<div class="gkr-cart-up__n">' + p.title + '</div>'
        + '<div class="gkr-cart-up__p">' + cmp + '<b>' + money(p.price) + '</b></div>'
        + '<button type="button" class="gkr-cart-up__add" data-gkr-cart-upadd="' + v.id + '">AJOUTER</button>'
        + '</div>';
    }
    function loadReco(cart) {
      if (!railListEl) return;
      var ids = [], inCart = {};
      cart.items.forEach(function (it) { if (insVids[it.variant_id]) return; ids.push(it.product_id); inCart[it.product_id] = 1; });
      var sig = ids.slice().sort().join(',');
      if (sig === lastRecoSig) return;            // pas de changement de produits → on ne refait pas l'appel
      lastRecoSig = sig;
      if (!ids.length) { railListEl.innerHTML = railFallback; showRail(!!railFallback.replace(/\s/g, '')); return; }
      fetch('/recommendations/products.json?intent=related&limit=10&product_id=' + ids[0], { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var recs = (data && data.products ? data.products : []).filter(function (p) { return !inCart[p.id] && p.id !== inspId && p.variants && p.variants.length; });
          if (recs.length) { railListEl.innerHTML = recs.slice(0, 4).map(upCard).join(''); showRail(true); }
          else if (railFallback.replace(/\s/g, '')) { railListEl.innerHTML = railFallback; showRail(true); }
          else { showRail(false); }
        })
        .catch(function () { if (railFallback.replace(/\s/g, '')) { railListEl.innerHTML = railFallback; showRail(true); } });
    }
    /* ---- assurance colis : 3 paliers (% du panier) via produit à variantes-paliers ---- */
    function loadInsProduct() {
      if (!insHandle || insMap) return Promise.resolve();
      return fetch('/products/' + insHandle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (p) {
          insMap = {};
          p.variants.forEach(function (v) { insMap[v.price] = v.id; insVids[v.id] = 1; if (v.price > insMaxCents) insMaxCents = v.price; });
          if (p.id && !inspId) inspId = p.id;
        })
        .catch(function () { insMap = {}; });
    }
    function insClamp(c) { return Math.max(100, Math.min(insMaxCents || 6000, c)); }
    function insAmount(base, lv) { return insClamp(Math.round(Math.round(base * lv / 100) / 100) * 100); } // % du panier, arrondi à l'euro (variantes en €)
    function insVariantFor(cents) {
      if (!insMap) return 0;
      if (insMap[cents]) return insMap[cents];
      var best = 0, bestD = Infinity;
      for (var k in insMap) { var d = Math.abs(k - cents); if (d < bestD) { bestD = d; best = insMap[k]; } }
      return best;
    }
    function findInsLine(cart) { for (var i = 0; i < cart.items.length; i++) { if (insVids[cart.items[i].variant_id]) return { item: cart.items[i], line: i + 1 }; } return null; }
    function insLevelOf(il) { var pr = il && il.item.properties; if (pr && pr._lvl) return parseInt(pr._lvl, 10) || 0; return 0; }
    function renderIns(cart) {
      if (!insBox) return;
      if (!insMap) { insBox.hidden = true; return; }
      var il = findInsLine(cart);
      var base = cart.total_price - (il ? il.item.final_line_price : 0);
      var active = insLevelOf(il);
      insBox.hidden = base <= 0;
      insBox.querySelectorAll('[data-gkr-ins-level]').forEach(function (b) {
        var lv = parseInt(b.getAttribute('data-gkr-ins-level'), 10);
        var cents = base > 0 ? insAmount(base, lv) : 0;
        var pe = b.querySelector('[data-gkr-ins-price]');
        if (pe) pe.textContent = cents > 0 ? money(cents) : '—';
        b.classList.toggle('is-on', lv === active);
      });
    }
    function insSet(level) {
      if (busy || !insMap) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var il = findInsLine(cart);
        if (il && insLevelOf(il) === level) { change(il.line, 0); return; } // re-clic sur le palier actif → retirer
        var base = cart.total_price - (il ? il.item.final_line_price : 0);
        if (base <= 0) return;
        var vid = insVariantFor(insAmount(base, level));
        if (!vid) return;
        busy = true; dr.classList.add('is-busy');
        var step = il ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: il.line, quantity: 0 }) }) : Promise.resolve();
        step.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1, properties: { _lvl: String(level), 'Assurance colis': level + '% du panier' } }) });
        }).then(refresh).catch(function () {}).then(done);
      });
    }
    function open() { dr.hidden = false; dr.classList.remove('is-closing'); document.documentElement.style.overflow = 'hidden'; refresh(); loadInsProduct().then(refresh); }
    function close() { dr.classList.add('is-closing'); document.documentElement.style.overflow = ''; setTimeout(function () { dr.hidden = true; dr.classList.remove('is-closing'); }, 300); }
    if (itemsEl) itemsEl.addEventListener('click', function (e) { var b = e.target.closest('button[data-line]'); if (b) change(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-q'), 10)); });
    if (railEl) railEl.addEventListener('click', function (e) { var b = e.target.closest('[data-gkr-cart-upadd]'); if (b) { var id = parseInt(b.getAttribute('data-gkr-cart-upadd'), 10); if (id) add(id, 1); } });
    if (insBox) insBox.addEventListener('click', function (e) { var b = e.target.closest('[data-gkr-ins-level]'); if (b) insSet(parseInt(b.getAttribute('data-gkr-ins-level'), 10)); });
    var pBtn = dr.querySelector('[data-gkr-promo-apply]'), pIn = dr.querySelector('[data-gkr-promo]');
    if (pBtn && pIn) { pBtn.addEventListener('click', function () { var c = (pIn.value || '').trim(); if (c) window.location.href = '/discount/' + encodeURIComponent(c) + '?redirect=/cart'; }); }
    document.querySelectorAll('[data-gkr-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    dr.querySelectorAll('[data-gkr-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) close(); });
    // réassurance défilante sous le titre (Paiement sécurisé · Livraison discrète · 100% Légal en France)
    var ticks = dr.querySelectorAll('[data-tick]');
    if (ticks.length > 1) {
      var tIdx = 0;
      setInterval(function () {
        ticks[tIdx].classList.remove('is-active');
        tIdx = (tIdx + 1) % ticks.length;
        ticks[tIdx].classList.add('is-active');
      }, 2600);
    }
    window.gkrOpenCart = function () { open(); };
  }

  /* ---- newsletter → inscription AJAX (Shopify + Klaviyo), confirmation INLINE sans rechargement ----
     Avant : le form se soumettait nativement → rechargement → état Shopify « posted » (le message
     « Code BIENVENUE10 envoyé » restait affiché, infos remontées). Maintenant : preventDefault, on
     inscrit en arrière-plan comme le pop-up, et on bascule la box en confirmation sur place. */
  function newsletter() {
    var KEY = 'gkr_news_sub'; // mémorise l'inscription → ne redemande plus le mail
    document.querySelectorAll('.gkr-news').forEach(function (sec) {
      if (sec.__gkr) return; sec.__gkr = 1;
      var pub = sec.getAttribute('data-gkr-klaviyo'), list = sec.getAttribute('data-gkr-klaviyo-list');
      var form = sec.querySelector('form');
      if (!form) return;
      var box = sec.querySelector('.gkr-news__box');
      // bascule en confirmation (idempotent, hauteur stable → rien ne « remonte »)
      function showOk() {
        if (box) box.setAttribute('data-done', '1');
        if (form.querySelector('.gkr-news__ok')) return;        // déjà en confirmation
        var p = document.createElement('p');
        p.className = 'gkr-news__ok';
        p.textContent = '👑 ' + (sec.getAttribute('data-gkr-ok') || 'Bienvenue dans la cour !'); // textContent = anti-XSS
        form.textContent = '';
        form.appendChild(p);
      }
      var done = false;
      try { done = !!localStorage.getItem(KEY); } catch (e0) {}
      // déjà inscrit (localStorage) OU succès serveur no-JS → confirmation direct, plus de re-saisie
      if (done || form.querySelector('.gkr-news__ok')) {
        try { localStorage.setItem(KEY, '1'); } catch (e0) {}
        showOk();
        return;                                                 // ✅ on ne rebranche pas le formulaire
      }
      form.addEventListener('submit', function (e) {
        var inp = form.querySelector('input[type=email]');
        var email = inp && inp.value ? inp.value.trim() : '';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return; // email vide/invalide → laisse le navigateur le signaler
        e.preventDefault();                                    // ✅ plus de reload
        try { localStorage.setItem(KEY, '1'); } catch (e0) {}  // ✅ mémorise l'inscription
        // 1) Shopify : crée le contact + tag (même endpoint que le pop-up)
        try {
          fetch('/contact', {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'form_type=customer&utf8=%E2%9C%93&contact[tags]=newsletter,prospect&contact[email]=' + encodeURIComponent(email)
          });
        } catch (e2) {}
        // 2) Klaviyo : déclenche le flux Bienvenue (l'e-mail qui contient le code)
        if (pub && list) {
          try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pub), {
              method: 'POST', keepalive: true,
              headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
            });
          } catch (e2) {}
        }
        // 3) confirmation inline
        showOk();
      });
    });
  }

  /* ---- pop-up bienvenue -10% (A/B) — inscrit Shopify + Klaviyo ---- */
  function popup() {
    var p = document.querySelector('[data-gkr-pop]');
    if (!p || p.__gkr) return; p.__gkr = 1;
    var qs = location.search;
    var force = qs.indexOf('popup=1') > -1;
    var design = !!(window.Shopify && window.Shopify.designMode); // éditeur de thème → on l'affiche pour le voir/régler

    /* ---- A/B : tirage de variante (50/50, persistant par visiteur) ---- */
    var isAB = p.getAttribute('data-ab') === '1';
    var variant = 'A';
    if (isAB) {
      var VKEY = 'gkr_pop_variant';
      var forced = (qs.match(/[?&]v=([abAB])(?:[&]|$)/) || [])[1];
      var assigned = '';
      if (design) {
        // Éditeur : on prévisualise le style choisi dans « Style affiché » (les vrais visiteurs gardent le 50/50)
        assigned = (p.getAttribute('data-preview-variant') || 'A').toUpperCase();
      } else {
        try { assigned = localStorage.getItem(VKEY) || ''; } catch (e) {}
        if (forced) { assigned = forced.toUpperCase(); }     // ?v=A / ?v=B force pour tester (non persistant)
        if (assigned !== 'A' && assigned !== 'B') {
          assigned = Math.random() < 0.5 ? 'A' : 'B';
          try { localStorage.setItem(VKEY, assigned); } catch (e) {}
        }
      }
      variant = assigned;
      // on ne garde QUE la variante retenue dans le DOM (un seul formulaire actif)
      p.querySelectorAll('[data-variant]').forEach(function (b) {
        if (b.getAttribute('data-variant') === variant) { b.hidden = false; }
        else if (b.parentNode) { b.parentNode.removeChild(b); }
      });
    } else {
      var only = p.querySelector('[data-variant]');
      if (only) { only.hidden = false; variant = only.getAttribute('data-variant') || 'A'; }
    }
    p.setAttribute('data-active-variant', variant);

    var KEY = 'gkr_pop_v1', state = '';
    try { state = localStorage.getItem(KEY) || ''; } catch (e) {}
    var freqDays = parseInt(p.getAttribute('data-freq'), 10) || 30;
    var suppressed = false; // bloque seulement l'affichage AUTO (déjà inscrit / déjà vu récemment) — l'ouverture MANUELLE (bouton) reste possible
    if (!force && !design) {
      if (state === 'done') suppressed = true;
      else if (state) { var pts = parseInt(state, 10); if (pts && (Date.now() - pts) < freqDays * 864e5) suppressed = true; }
    }
    var delay = (parseInt(p.getAttribute('data-delay'), 10) || 7) * 1000;
    var pub = p.getAttribute('data-kl-public'), list = p.getAttribute('data-kl-list'), shown = false;
    function open() {
      if (shown) return; shown = true;
      p.hidden = false; p.classList.remove('is-closing');
      document.documentElement.style.overflow = 'hidden';
      if (!design) { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} } // l'éditeur ne pollue pas le plafond de fréquence
    }
    function close() { p.classList.add('is-closing'); document.documentElement.style.overflow = ''; setTimeout(function () { p.hidden = true; p.classList.remove('is-closing'); }, 280); }
    p.__gkrOpen = function () { shown = false; open(); }; // ouverture à la demande (bouton « Je récupère mon code »)
    if (design) {
      open(); // visible d'emblée dans l'éditeur de thème
      document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains && e.target.contains(p)) { shown = false; open(); } });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains && e.target.contains(p)) { close(); } });
    } else if (force) { open(); }
    else if (!suppressed) {
      var timer = setTimeout(open, delay);
      document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !shown) { clearTimeout(timer); open(); } });
    }
    p.querySelectorAll('[data-gkr-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) close(); });
    var form = p.querySelector('[data-gkr-pop-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = p.querySelector('[data-gkr-pop-email]'), err = p.querySelector('[data-gkr-pop-err]');
        var email = ((input && input.value) || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (err) err.hidden = false; return; }
        if (err) err.hidden = true;
        var btn = form.querySelector('.gkr-pop__btn'); if (btn) { btn.disabled = true; btn.textContent = 'Un instant…'; }
        var vtag = 'popup-' + variant.toLowerCase();   // popup-a / popup-b → mesure A/B
        try { fetch('/contact', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'form_type=customer&utf8=%E2%9C%93&contact[tags]=newsletter,popup,' + vtag + '&contact[email]=' + encodeURIComponent(email) }); } catch (e) {}
        if (pub && list) {
          try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pub), {
              method: 'POST', keepalive: true, headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Pop-up -10% (Variante ' + variant + ')', profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Pop-up variante': variant } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
            });
          } catch (e) {}
        }
        if (!design) { try { localStorage.setItem(KEY, 'done'); } catch (e) {} }
        form.hidden = true;
        var ok = p.querySelector('[data-gkr-pop-success]'); if (ok) ok.hidden = false;
        p.querySelectorAll('.gkr-pop__decline, .gkr-pop__trust').forEach(function (el) { el.style.display = 'none'; });
      });
    }
    var code = p.querySelector('[data-gkr-pop-code]');
    if (code) {
      code.addEventListener('click', function () {
        var txt = code.textContent.trim(), done = function () { var c = p.querySelector('[data-gkr-pop-copied]'); if (c) c.hidden = false; };
        if (navigator.clipboard) { navigator.clipboard.writeText(txt).then(done).catch(done); } else { done(); }
      });
    }
  }

  /* ---- Roue de la fortune (truquée -10% par défaut) — inscrit Shopify + Klaviyo ---- */
  function roue() {
    var r = document.querySelector('[data-gkr-roue]');
    if (!r || r.__gkr) return; r.__gkr = 1;
    var cfgEl = r.querySelector('[data-gkr-roue-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var segs = (cfg.segments || []).filter(function (x) { return x && (x.l1 || x.l2); });
    if (!segs.length) return;
    var copy = cfg.copy || {};
    var N = segs.length, SEG = 360 / N, R = 188, C = 200;
    var force = location.search.indexOf('roue=1') > -1;
    var design = !!(window.Shopify && window.Shopify.designMode);

    function esc(t) { return String(t == null ? '' : t).replace(/[<&>]/g, function (c) { return { '<': '&lt;', '&': '&amp;', '>': '&gt;' }[c]; }); }
    function pol(ang, rad) { var a = ang * Math.PI / 180; return [C + rad * Math.cos(a), C + rad * Math.sin(a)]; }

    /* déclenchement / fréquence */
    var KEY = 'gkr_roue_v1', state = '';
    try { state = localStorage.getItem(KEY) || ''; } catch (e) {}
    var freqDays = parseInt(r.getAttribute('data-freq'), 10) || 30;
    var suppressed = false; // bloque seulement l'affichage AUTO (déjà joué / déjà vu récemment) — ouverture MANUELLE (bouton) toujours permise
    if (!force && !design) {
      if (state === 'done') suppressed = true;
      else if (state) { var rts = parseInt(state, 10); if (rts && (Date.now() - rts) < freqDays * 864e5) suppressed = true; }
    }

    /* construction de la roue (SVG) */
    var svg = '<svg viewBox="0 0 400 400" aria-hidden="true"><circle cx="200" cy="200" r="197" fill="#0c0b08" stroke="#c8a24b" stroke-width="3"></circle>';
    for (var i = 0; i < N; i++) {
      var start = -90 + i * SEG, mid = start + SEG / 2;
      var p1 = pol(start, R), p2 = pol(start + SEG, R), seg = segs[i];
      var fill = seg.fill || (i % 2 === 0 ? '#15140f' : '#c8a24b');
      var tcol = seg.text || (i % 2 === 0 ? '#e0c684' : '#0a0a09');
      svg += '<path d="M200,200 L' + p1[0].toFixed(2) + ',' + p1[1].toFixed(2) + ' A188,188 0 0 1 ' + p2[0].toFixed(2) + ',' + p2[1].toFixed(2) + ' Z" fill="' + fill + '" stroke="#c8a24b" stroke-width="2"></path>';
      var dot = pol(mid, 175);
      svg += '<circle cx="' + dot[0].toFixed(2) + '" cy="' + dot[1].toFixed(2) + '" r="3.4" fill="' + (i % 2 === 0 ? '#c8a24b' : '#15140f') + '"></circle>';
      var tp = pol(mid, 112), two = seg.l2 && String(seg.l2).length, fs = two ? 21 : 26;
      svg += '<text x="' + tp[0].toFixed(2) + '" y="' + tp[1].toFixed(2) + '" fill="' + tcol + '" font-family="&quot;Anton&quot;,sans-serif" font-size="' + fs + '" text-anchor="middle" dominant-baseline="middle" transform="rotate(' + (mid + 90).toFixed(2) + ' ' + tp[0].toFixed(2) + ' ' + tp[1].toFixed(2) + ')" style="letter-spacing:.02em">';
      svg += two ? '<tspan x="' + tp[0].toFixed(2) + '" dy="-10">' + esc(seg.l1) + '</tspan><tspan x="' + tp[0].toFixed(2) + '" dy="21">' + esc(seg.l2) + '</tspan>' : '<tspan x="' + tp[0].toFixed(2) + '" dy="0">' + esc(seg.l1) + '</tspan>';
      svg += '</text>';
    }
    svg += '<circle cx="200" cy="200" r="188" fill="none" stroke="#e0c684" stroke-width="2" opacity="0.5"></circle></svg>';
    var wheelEl = r.querySelector('[data-gkr-roue-wheel]');
    wheelEl.innerHTML = svg;
    var svgEl = wheelEl.querySelector('svg');

    /* ouverture / fermeture */
    var delay = (parseInt(r.getAttribute('data-delay'), 10) || 7) * 1000, shown = false;
    function open() { if (shown) return; shown = true; r.hidden = false; r.classList.remove('is-closing'); document.documentElement.style.overflow = 'hidden'; if (!design) { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} } }
    function close() { r.classList.add('is-closing'); document.documentElement.style.overflow = ''; setTimeout(function () { r.hidden = true; r.classList.remove('is-closing'); }, 280); }
    r.__gkrOpen = function () { shown = false; open(); }; // ouverture à la demande (bouton « Je récupère mon code »)
    if (design) {
      open();
      document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains && e.target.contains(r)) { shown = false; open(); } });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains && e.target.contains(r)) close(); });
    } else if (force) { open(); }
    else if (!suppressed) { var timer = setTimeout(open, delay); document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !shown) { clearTimeout(timer); open(); } }); }
    r.querySelectorAll('[data-gkr-roue-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !r.hidden) close(); });

    /* choix du lot gagnant */
    function pickWinner() {
      if (r.getAttribute('data-mode') !== 'random') {
        for (var i = 0; i < N; i++) { if (segs[i].win) return i; }
        for (var j = 0; j < N; j++) { if (!segs[j].loss) return j; }
        return 0;
      }
      var total = 0, w = segs.map(function (s) { var x = Math.max(0, +s.weight || 0); total += x; return x; });
      if (total <= 0) return Math.floor(Math.random() * N);
      var rnd = Math.random() * total, acc = 0;
      for (var k = 0; k < N; k++) { acc += w[k]; if (rnd < acc) return k; }
      return N - 1;
    }

    /* animation du tour */
    var spins = parseInt(r.getAttribute('data-spins'), 10) || 6, rounds = 0;
    function spinTo(k, done) {
      rounds += spins;
      var jitter = (Math.random() * 2 - 1) * (SEG / 2 - 7);
      var rot = 360 * rounds - (k * SEG + SEG / 2) + jitter;
      svgEl.style.setProperty('--gkr-spin-dur', (3.8 + Math.random() * 0.8).toFixed(2) + 's');
      wheelEl.classList.add('is-spinning');
      requestAnimationFrame(function () { svgEl.style.transform = 'rotate(' + rot.toFixed(2) + 'deg)'; });
      var ended = false, end = function () { if (ended) return; ended = true; done(); };
      svgEl.addEventListener('transitionend', end, { once: true });
      setTimeout(end, 5200);
    }

    /* capture + révélation */
    var pub = r.getAttribute('data-kl-public'), list = r.getAttribute('data-kl-list'), abtag = r.getAttribute('data-ab') || 'roue';
    var formView = r.querySelector('[data-gkr-roue-form]'), resultView = r.querySelector('[data-gkr-roue-result]'), formEl = r.querySelector('[data-gkr-roue-formel]'), busy = false, lastEmail = '';

    // Le code arrive par email (flux Klaviyo) → le bouton ouvre la webmail du visiteur (sinon son client mail par défaut)
    function openMail(email) {
      var d = ((email || '').split('@')[1] || '').toLowerCase();
      var box = {
        'gmail.com': 'https://mail.google.com/mail/u/0/', 'googlemail.com': 'https://mail.google.com/mail/u/0/',
        'outlook.com': 'https://outlook.live.com/mail/0/', 'outlook.fr': 'https://outlook.live.com/mail/0/',
        'hotmail.com': 'https://outlook.live.com/mail/0/', 'hotmail.fr': 'https://outlook.live.com/mail/0/',
        'live.com': 'https://outlook.live.com/mail/0/', 'live.fr': 'https://outlook.live.com/mail/0/', 'msn.com': 'https://outlook.live.com/mail/0/',
        'yahoo.com': 'https://mail.yahoo.com/', 'yahoo.fr': 'https://mail.yahoo.com/', 'ymail.com': 'https://mail.yahoo.com/',
        'orange.fr': 'https://webmail.orange.fr/', 'wanadoo.fr': 'https://webmail.orange.fr/',
        'free.fr': 'https://webmail.free.fr/', 'sfr.fr': 'https://webmail.sfr.fr/', 'neuf.fr': 'https://webmail.sfr.fr/',
        'laposte.net': 'https://www.laposte.net/accueil', 'bbox.fr': 'https://www.bbox-mail.fr/',
        'icloud.com': 'https://www.icloud.com/mail', 'me.com': 'https://www.icloud.com/mail',
        'proton.me': 'https://mail.proton.me/', 'protonmail.com': 'https://mail.proton.me/'
      };
      if (box[d]) { window.open(box[d], '_blank', 'noopener'); }
      else { try { window.location.href = 'mailto:'; } catch (e) {} }
    }

    function capture(email) {
      try { fetch('/contact', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'form_type=customer&utf8=%E2%9C%93&contact[tags]=newsletter,popup,' + encodeURIComponent(abtag) + '&contact[email]=' + encodeURIComponent(email) }); } catch (e) {}
      if (pub && list) {
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pub), {
            method: 'POST', keepalive: true, headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Roue de la fortune', profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Pop-up variante': abtag } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
          });
        } catch (e) {}
      }
    }

    function reveal(k) {
      var seg = segs[k], lot = ((seg.l1 || '') + (seg.l2 ? ' ' + seg.l2 : '')).trim(), win = !seg.loss, html = '';
      if (win) {
        html += '<div class="gkr-roue__r-emoji">' + esc(copy.winEmoji || '👑') + '</div>';
        html += '<div class="gkr-roue__r-title">' + esc(copy.winTitle || 'TU AS GAGNÉ !') + '</div>';
        html += '<p class="gkr-roue__r-body">' + esc((copy.winBody || '').replace(/\[lot\]/g, lot || 'ton lot')) + '</p>';
        html += '<button type="button" class="gkr-roue__r-cta" data-gkr-roue-mail>' + esc(copy.winCta || 'J’OUVRE MES MAILS') + '</button>';
        if (copy.winNote) html += '<div class="gkr-roue__r-note">' + esc(copy.winNote) + '</div>';
      } else {
        html += '<div class="gkr-roue__r-emoji">' + esc(copy.loseEmoji || '🍃') + '</div>';
        html += '<div class="gkr-roue__r-title">' + esc(copy.loseTitle || 'PAS DE CHANCE…') + '</div>';
        html += '<p class="gkr-roue__r-body">' + esc(copy.loseBody || '') + '</p>';
        html += '<button type="button" class="gkr-roue__r-cta" data-gkr-roue-retry>' + esc(copy.loseCta || 'JE RETENTE') + '</button>';
      }
      resultView.innerHTML = html;
      formView.hidden = true; resultView.hidden = false;
      resultView.querySelectorAll('[data-gkr-roue-close]').forEach(function (b) { b.addEventListener('click', close); });
      var mailBtn = resultView.querySelector('[data-gkr-roue-mail]');
      if (mailBtn) mailBtn.addEventListener('click', function () { openMail(lastEmail); close(); });
      var retry = resultView.querySelector('[data-gkr-roue-retry]');
      if (retry) retry.addEventListener('click', function () { resultView.hidden = true; formView.hidden = false; busy = false; });
    }

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var input = r.querySelector('[data-gkr-roue-email]'), err = r.querySelector('[data-gkr-roue-err]');
        var email = ((input && input.value) || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (err) err.hidden = false; return; }
        if (err) err.hidden = true;
        lastEmail = email;
        busy = true;
        var btn = r.querySelector('[data-gkr-roue-spin]'); if (btn) { btn.disabled = true; btn.textContent = copy.spinning || 'La roue tourne…'; }
        capture(email);
        if (!design) { try { localStorage.setItem(KEY, 'done'); } catch (e) {} }
        var k = pickWinner();
        spinTo(k, function () { reveal(k); });
      });
    }
  }

  /* ---- Ouverture à la demande du pop-up de bienvenue (roue ou formulaire) via [data-gkr-pop-open] ---- */
  window.gkrOpenWelcome = function () {
    var r = document.querySelector('[data-gkr-roue]');
    if (r && r.__gkrOpen) { r.__gkrOpen(); return true; }
    var p = document.querySelector('[data-gkr-pop]');
    if (p && p.__gkrOpen) { p.__gkrOpen(); return true; }
    return false;
  };
  function popTriggers() {
    document.querySelectorAll('[data-gkr-pop-open]').forEach(function (b) {
      if (b.__gkrBound) return; b.__gkrBound = 1;
      b.addEventListener('click', function (e) { e.preventDefault(); if (window.gkrOpenWelcome) window.gkrOpenWelcome(); });
    });
  }

  /* ---- Bande promo : bascule promo → formulaire → code (inscrit Shopify + Klaviyo) ---- */
  function promoFlip() {
    document.querySelectorAll('[data-gkr-promo]').forEach(function (box) {
      if (box.__gkr) return; box.__gkr = 1;
      var panels = {};
      box.querySelectorAll('[data-panel]').forEach(function (p) { panels[p.getAttribute('data-panel')] = p; });
      function setMode(m) {
        box.setAttribute('data-mode', m);
        Object.keys(panels).forEach(function (k) { panels[k].hidden = (k !== m); });
        if (m === 'form') { var fi = panels.form.querySelector('input[name="first"]') || panels.form.querySelector('input[name="email"]'); if (fi) { try { fi.focus(); } catch (e) {} } }
      }
      var startBtn = box.querySelector('[data-gkr-promo-start]');
      if (startBtn) startBtn.addEventListener('click', function () { setMode('form'); });
      var backBtn = box.querySelector('[data-gkr-promo-back]');
      if (backBtn) backBtn.addEventListener('click', function () { setMode('promo'); });
      var form = panels.form;
      if (form && form.tagName === 'FORM') {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var emailEl = form.querySelector('input[name="email"]'), firstEl = form.querySelector('input[name="first"]'), consent = form.querySelector('[data-consent]'), err = form.querySelector('[data-err]');
          var email = ((emailEl && emailEl.value) || '').trim(), first = ((firstEl && firstEl.value) || '').trim();
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || (consent && !consent.checked)) { if (err) err.hidden = false; return; }
          if (err) err.hidden = true;
          var btn = form.querySelector('.gkr-btn'); if (btn) { btn.disabled = true; btn.textContent = 'Un instant…'; }
          var pub = box.getAttribute('data-kl-public'), list = box.getAttribute('data-kl-list'), tags = box.getAttribute('data-tags') || 'newsletter,promo-inline';
          try { fetch('/contact', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'form_type=customer&utf8=%E2%9C%93&contact[tags]=' + encodeURIComponent(tags) + '&contact[email]=' + encodeURIComponent(email) }); } catch (e) {}
          if (pub && list) {
            var attrs = { email: email, properties: { 'Source': 'Bande promo -10%' } };
            if (first) attrs.first_name = first;
            try {
              fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pub), {
                method: 'POST', keepalive: true, headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
                body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Bande promo -10% (formulaire)', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
              });
            } catch (e) {}
          }
          var dn = panels.done.querySelector('[data-done-name]'); if (dn) dn.textContent = first ? ' ' + first.toUpperCase() : '';
          var de = panels.done.querySelector('[data-done-email]'); if (de) de.textContent = email;
          setMode('done');
        });
      }
      var codeBox = box.querySelector('[data-copy-code]');
      if (codeBox) {
        var doCopy = function () {
          var val = ((box.querySelector('.gkr-promo__codeval') || {}).textContent || '').trim();
          var lab = box.querySelector('[data-copy-label]'), ok = function () { if (lab) lab.textContent = 'Copié ✓'; };
          if (navigator.clipboard) { navigator.clipboard.writeText(val).then(ok).catch(ok); } else { ok(); }
        };
        codeBox.addEventListener('click', doCopy);
        codeBox.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doCopy(); } });
      }
      // éditeur de thème : repartir sur l'état promo à chaque (dé)sélection
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains && e.target.contains(box)) setMode('promo'); });
      }
    });
  }

  /* ---- recherche inline déployée + prédictive (Shopify suggest.json) ---- */
  function search() {
    var panel = document.querySelector('[data-gkr-search]');
    if (!panel || panel.__gkr) return;
    panel.__gkr = 1;
    var input = panel.querySelector('[data-gkr-search-input]'),
        results = panel.querySelector('[data-gkr-search-results]'),
        clearBtn = panel.querySelector('[data-gkr-search-clear]'),
        form = panel.querySelector('form'),
        action = (form && form.getAttribute('action')) || '/search',
        timer = null, lastQ = '', isOpen = false;

    function eur(s) { var n = parseFloat(s); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
    function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function open() {
      isOpen = true; panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      var dr = document.querySelector('[data-gkr-drawer]');
      if (dr && !dr.hidden) { dr.hidden = true; dr.classList.remove('is-closing'); }
      var hb = document.querySelector('[data-gkr-burger]'); if (hb) hb.setAttribute('aria-expanded', 'false');
      document.querySelectorAll('[data-gkr-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { if (input) input.focus(); }, 70);
    }
    function close() {
      isOpen = false; panel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.querySelectorAll('[data-gkr-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { panel.hidden = true; }, 220);
    }

    document.querySelectorAll('[data-gkr-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    panel.querySelectorAll('[data-gkr-search-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; lastQ = ''; results.innerHTML = ''; clearBtn.hidden = true; input.focus(); });

    function render(data, q) {
      var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!prods.length) { results.innerHTML = '<div class="gkr-search__empty">Aucun résultat pour « ' + esc(q) + ' »</div>'; return; }
      var h = '<div class="gkr-search__list">';
      prods.forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var price = p.price_min || p.price || '';
        h += '<a class="gkr-search__item" href="' + esc(p.url) + '">'
          + '<span class="gkr-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="gkr-search__meta"><span class="gkr-search__t">' + esc(p.title) + '</span>'
          + (price ? '<span class="gkr-search__p">dès ' + eur(price) + (p.available === false ? ' · épuisé' : '') + '</span>' : '')
          + '</span><span class="gkr-search__arrow">→</span></a>';
      });
      h += '</div><a class="gkr-search__all" href="' + esc(action) + '?q=' + encodeURIComponent(q) + '&type=product">Voir tous les résultats →</a>';
      results.innerHTML = h;
    }

    function fetchResults(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(function () {});
    }

    if (input) input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = !q;
      if (q.length < 2) { results.innerHTML = ''; lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      timer = setTimeout(function () { fetchResults(q); }, 220);
    });
  }

  /* ---- page collection : drawer filtres mobile + filtrage AJAX (sans rechargement) ---- */
  function collectionFilter() {
    document.querySelectorAll('[data-gkr-collection]').forEach(function (form) {
      if (form.__gkr) return;
      form.__gkr = 1;
      var sid = form.getAttribute('data-gkr-section-id'), busy = false;

      function aside() { return form.querySelector('[data-gkr-aside]'); }
      function backdrop() { return form.querySelector('.gkr-col-backdrop'); }
      function opened() { var a = aside(); return !!(a && a.classList.contains('open')); }
      function openF() { var a = aside(), b = backdrop(); if (a) a.classList.add('open'); if (b) b.hidden = false; document.documentElement.style.overflow = 'hidden'; }
      function closeF() { var a = aside(), b = backdrop(); if (a) a.classList.remove('open'); if (b) b.hidden = true; document.documentElement.style.overflow = ''; }

      // délégation sur le form (persiste au remplacement du contenu)
      form.addEventListener('click', function (e) {
        var tg = e.target.closest && e.target.closest('[data-gkr-filter-toggle]');
        if (tg) { e.preventDefault(); opened() ? closeF() : openF(); return; }
        var cl = e.target.closest && e.target.closest('[data-gkr-filter-close]');
        if (cl) { if (cl.tagName === 'A') return; e.preventDefault(); closeF(); return; }
        var chip = e.target.closest && e.target.closest('.gkr-chip');
        if (chip && chip.getAttribute('href')) { e.preventDefault(); load(chip.getAttribute('href'), true); return; }
        var pg = e.target.closest && e.target.closest('.gkr-col-pagination a');
        if (pg && pg.getAttribute('href')) { e.preventDefault(); load(pg.getAttribute('href'), true); try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (er) {} return; }
      });

      function buildUrl() {
        var fd = new FormData(form), params = new URLSearchParams();
        fd.forEach(function (v, k) { if (v !== '' && v != null && k !== 'section_id') params.append(k, v); });
        var qs = params.toString();
        return window.location.pathname + (qs ? '?' + qs : '');
      }

      function load(url, push) {
        if (busy) return; busy = true; form.classList.add('is-loading');
        var wasOpen = opened();
        if (push && window.history && history.pushState) { try { history.pushState({ gkr: 1 }, '', url); } catch (er) {} }
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nf = doc.querySelector('[data-gkr-collection]') || doc.querySelector('.gkr-col-body');
            if (nf) {
              form.innerHTML = nf.innerHTML;
              if (wasOpen) openF();
              form.querySelectorAll('[data-gkr-real]').forEach(wireCard);
            }
            busy = false; form.classList.remove('is-loading');
          })
          .catch(function () { busy = false; window.location.href = url; });
      }

      form.addEventListener('submit', function (e) { e.preventDefault(); load(buildUrl(), true); });
      window.addEventListener('popstate', function () { if (document.body.contains(form)) load(window.location.pathname + window.location.search, false); });
    });
  }

  function init() {
    document.querySelectorAll('[data-gkr-real]').forEach(wireCard);
    document.querySelectorAll('[data-gkr-gallery]').forEach(wireGallery);
    document.querySelectorAll('[data-gkr-pdp]').forEach(wirePdp);
    progress();
    header();
    drawer();
    cartDrawer();
    newsletter();
    popup();
    roue();
    popTriggers();
    promoFlip();
    search();
    collectionFilter();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
